import EventBus from 'src/components/EventBus.js'

var HandleUnexpectedError = {
  methods: {
    handleUnexpectedError() {
      if(this.fullScreenLoading) {
        this.fullScreenLoading = false
      }
      this.$modal.show('message-modal', {
        headerMessage: 'Error',
        bodyMessage: "There is an unexpected error. Please try again or contact our support."
      })
    }
  },
  created() {
    EventBus.$on('server-unexpected-error', this.handleUnexpectedError)
  },
  beforeDestroy() {
    EventBus.$off('server-unexpected-error', this.handleUnexpectedError)
  },
}

export default HandleUnexpectedError;
